export default "__VITE_ASSET__D72rlr0lQGIV8_jgzqQhcA__"